import { useEffect, useState } from "react";
import { _CashRequest, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { InputDate } from "../../../../theme/Input/InputDate";
import { InputMoney } from "../../../../theme/Input/InputMoney";
import { toast } from "react-toastify";
import { OfficeEditor } from "../../Office/OfficeEditor";
import { SelectInboxCash } from "../../CashDesk/SelectInboxCash";

interface Props {
    onChange: Function;
}

export const CreateRequestCash = ({ onChange }: Props) => {

    const { bean, setBean, handleChange } = useDataBean(_CashRequest);

    useEffect(() => {
        setBean({
            IDAccount: _single.getAccountID(),
            RequiresAdvance: false,
            CashRequestDate: _single.getCurrenDate(),
        })
    }, [])

    const [office, setOffice] = useState<number>(null);

    useEffect(() => { onChange(bean) }, [bean]);

    return (
        <div className="row">
            <div className="col-md-6">
                <label>Fecha de la solicitud</label>
                <InputDate name="CashRequestDate" label=" " value={bean.CashRequestDate} setDate={(e) => { setBean({ ...bean, "CashRequestDate": e }) }} />
            </div>
            <div className="col-md-6">
                <OfficeEditor label="Ciudad" id={office} idconpany={null} onchange={(e: any) => { setOffice(e) }} />
            </div>
            {office &&
                <div className="col-md-6">
                    <SelectInboxCash city={office} idSelector={bean.IDCashDeskAccount} onChange={(e) => { setBean({ ...bean, IDCashDeskAccount: e }) }} />
                </div>
            }
            <div className="col-md-6 d-flex align-items-center">
                <BasicSwitch estado={bean.RequiresAdvance} eventChange={(e) => { setBean({ ...bean, "RequiresAdvance": e }) }} label="Requiere Anticipo" />
            </div>
            {bean.RequiresAdvance &&
                <div className="col-md-6">
                    <InputMoney _label="Valor a Anticipar" _value={bean.AdvanceValue} onChange={(e) => { setBean({ ...bean, "AdvanceValue": e }) }} />
                </div>
            }
            <div className="col-12">
                <label >Descripción</label>
                <textarea value={bean.Description} name="Description" className="form-control" onChange={handleChange} rows={4} />
            </div>
        </div>
    )
}